import env from 'configuration'
import { AuthInit } from 'context/auth'
import useScript from 'hooks/script'
import { useRoutes } from 'react-router-dom'
import Routes from 'routing/routes'

function App() {
  const routes = useRoutes(Routes())

  // Load the Google Maps JS API (same as the web dashboard) so window.google.maps
  // is available to map/places components across the operator app.
  useScript(
    `https://maps.googleapis.com/maps/api/js?key=${env.G_MAP_API_KEY}&loading=async&libraries=places`
  )

  return (
    <div className='h-screen overflow-y-auto relative'>
      <AuthInit>{routes}</AuthInit>
    </div>
  )
}

export default App
